import { api } from '../api/client.js';
import { ENDPOINTS } from '../api/endpoints.js';
import { API_CONFIG } from '../api/config.js';
import { mockBotReplies } from '../mocks/bot.js';
import { getLang } from '../i18n/index.js';

const delay = (ms = 550) => new Promise((r) => setTimeout(r, ms));

export const botService = {
  async send(message, scenarioId = null) {
    if (API_CONFIG.useMocks) {
      await delay();
      const lang = getLang();
      const pick = mockBotReplies[Math.floor(Math.random() * mockBotReplies.length)];
      return { reply: pick[lang] || pick.en };
    }
    try {
      const res = await api.post(ENDPOINTS.bot.send(), {
        message,
        scenario_id: scenarioId,
        language: getLang(),
        user_id: 'anonymous',
      });
      return { reply: res.reply };
    } catch (err) {
      await delay();
      const lang = getLang();
      const pick = mockBotReplies[Math.floor(Math.random() * mockBotReplies.length)];
      return { reply: pick[lang] || pick.en };
    }
  },
  async getHistory(scenarioId = null) {
    if (API_CONFIG.useMocks) return { messages: [] };
    try {
      return await api.get(ENDPOINTS.bot.history(scenarioId));
    } catch {
      return { messages: [] };
    }
  },
};